// import { useState, useRef } from 'react';
// import PropTypes from 'prop-types';

// const KeyFocusSection = ({ 
//   title, 
//   highlightedText, 
//   description, 
//   focusAreas,
//   // backgroundColor = '#f7fafc'
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [touchStart, setTouchStart] = useState(null);
//   const [touchEnd, setTouchEnd] = useState(null);
//   const carouselRef = useRef(null);

//   // Minimum swipe distance (in px)
//   const minSwipeDistance = 50;

//   // Calculate how many cards to show based on screen size
//   const getCardsToShow = () => {
//     if (typeof window !== 'undefined') {
//       if (window.innerWidth >= 1024) return 3; // Desktop: 3 cards
//       if (window.innerWidth >= 768) return 2;  // Tablet: 2 cards
//       return 1; // Mobile: 1 card
//     }
//     return 3;
//   };

//   const cardsToShow = getCardsToShow();
//   const maxIndex = Math.max(0, focusAreas.length - cardsToShow);

//   const handlePrev = () => {
//     setCurrentIndex((prev) => Math.max(0, prev - 1));
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
//   };

//   // Touch handlers for swipe functionality
//   const onTouchStart = (e) => {
//     setTouchEnd(null);
//     setTouchStart(e.targetTouches[0].clientX);
//   };

//   const onTouchMove = (e) => {
//     setTouchEnd(e.targetTouches[0].clientX);
//   };

//   const onTouchEnd = () => {
//     if (!touchStart || !touchEnd) return;
    
//     const distance = touchStart - touchEnd;
//     const isLeftSwipe = distance > minSwipeDistance;
//     const isRightSwipe = distance < -minSwipeDistance;

//     if (isLeftSwipe && currentIndex < maxIndex) {
//       handleNext();
//     }
//     if (isRightSwipe && currentIndex > 0) {
//       handlePrev();
//     }
//   };

//   // Check if arrows should be visible
//   const showLeftArrow = currentIndex > 0;
//   const showRightArrow = currentIndex < maxIndex;

//   return (
//     <section className="py-14 md:py-18">
//       <div className="container mx-auto px-4">
//         {/* Header Section */}
//         <div className="text-center mb-12 max-w-4xl mx-auto">
//           <h2 className="font-bold text-gray-800 mb-6">
//             <span className='secondary-text'>
//               {highlightedText}
//             </span>{' '}
//             <span className=''>
//             {title}
//             </span>
//           </h2>
//           <p className="   leading-relaxed">
//             {description}
//           </p>
//         </div>

//         {/* Carousel Container - Increased width */}
//         <div className="relative max-w-6xl mx-auto px-12 md:px-16 lg:px-20">
//           {/* Left Arrow - Only visible when not at start */}
//           {showLeftArrow && (
//             <button
//               onClick={handlePrev}
//               className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 z-10 transition-all bg-transparent border-none p-0"
//               aria-label="Previous"
//             >
//               <img src='/assets/images/platform-left-arrow.svg' alt="Previous" className="w-14 h-14 block" />
//             </button>
//           )}

//           {/* Cards Container */}
//           <div className="overflow-hidden">
//             <div
//               className="flex transition-transform duration-500 ease-out"
//               style={{
//                 transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`
//               }}
//             >
//               {focusAreas.map((area, index) => (
//                 <div
//                   key={index}
//                   className="flex-shrink-0 px-3 md:px-4"
//                   style={{ width: `${100 / cardsToShow}%` }}
//                 >
//                   <div
//                     className="rounded-lg overflow-hidden shadow-lg h-full primary-bg"
//                   >
//                     {/* Card Title */}
//                     <div className="text-white text-center py-4 px-4">
//                       <h3 className="  font-bold">
//                         {area.title}
//                       </h3>
//                     </div>

//                     {/* Card Image */}
//                     <div className="bg-white mx-4 mb-4 rounded-lg overflow-hidden">
//                       <img
//                         src={area.image}
//                         alt={area.title}
//                         className="w-full h-40 md:h-48 object-cover"
//                       />
//                     </div>

//                     {/* Card Description */}
//                     <div className="text-white text-center px-4 pb-5">
//                       <p className=" leading-relaxed">
//                         {area.description}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Right Arrow - Only visible when not at end */}
//           {showRightArrow && (
//             <button
//               onClick={handleNext}
//               className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 z-10 transition-all border-none p-0"
//               aria-label="Next"
//             >
//               <img src='/assets/images/paltform-right-arrow.svg' alt="Next" className="w-14 h-14" />
//             </button>
//           )}
//           {/* Dot Indicators for Mobile - Only show when there are multiple cards */}
//           {focusAreas.length > 1 && (
//             <div className="flex justify-center gap-2 mt-6 md:hidden">
//               {Array.from({ length: focusAreas.length }).map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => setCurrentIndex(index)}
//                   className={`w-2 h-2 rounded-full transition-all duration-300 ${
//                     index === currentIndex
//                       ? 'bg-blue-600 w-6'
//                       : 'bg-gray-400'
//                   }`}
//                   aria-label={`Go to slide ${index + 1}`}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// KeyFocusSection.propTypes = {
//   title: PropTypes.string.isRequired,
//   highlightedText: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
//   focusAreas: PropTypes.arrayOf(
//     PropTypes.shape({
//       title: PropTypes.string.isRequired,
//       image: PropTypes.string.isRequired,
//       description: PropTypes.string.isRequired,
//     })
//   ).isRequired,
//   backgroundColor: PropTypes.string,
// };

// export default KeyFocusSection;

import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const KeyFocusSection = ({ 
  title, 
  highlightedText, 
  description, 
  focusAreas,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [cardsToShow, setCardsToShow] = useState(1);
  const carouselRef = useRef(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  // Calculate how many cards to show based on screen size
  const getCardsToShow = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= 1024) return 3; // Desktop: 3 cards
      if (window.innerWidth >= 768) return 2;  // Tablet: 2 cards
      return 1; // Mobile: 1 card
    }
    return 1;
  };

  // Update cards to show on mount and resize
  useEffect(() => {
    const updateCardsToShow = () => {
      setCardsToShow(getCardsToShow());
    };

    // Set initial value
    updateCardsToShow();

    // Add resize listener
    window.addEventListener('resize', updateCardsToShow);

    // Cleanup
    return () => window.removeEventListener('resize', updateCardsToShow);
  }, []);

  // Reset current index when cards to show changes
  useEffect(() => {
    const maxIdx = Math.max(0, focusAreas.length - cardsToShow);
    if (currentIndex > maxIdx) {
      setCurrentIndex(maxIdx);
    }
  }, [cardsToShow, focusAreas.length, currentIndex]);

  const maxIndex = Math.max(0, focusAreas.length - cardsToShow);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
  };

  // Touch handlers for swipe functionality
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentIndex < maxIndex) {
      handleNext();
    }
    if (isRightSwipe && currentIndex > 0) {
      handlePrev();
    }
  };

  // Check if arrows should be visible
  const showLeftArrow = currentIndex > 0;
  const showRightArrow = currentIndex < maxIndex;

  return (
    <section className="py-14 md:py-18">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="font-bold text-gray-800 mb-6">
            <span className='secondary-text'>
              {highlightedText}
            </span>{' '}
            <span className=''>
            {title}
            </span>
          </h2>
          <p className="  leading-relaxed">
            {description}
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative max-w-6xl mx-auto px-4 md:px-12 lg:px-20">
          {/* Left Arrow - Hidden on mobile, visible on desktop */}
          {showLeftArrow && (
            <button
              onClick={handlePrev}
              className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 z-10 transition-all bg-transparent border-none p-0"
              aria-label="Previous"
            >
              <img src='/assets/images/platform-left-arrow.svg' alt="Previous" className="w-14 h-14 block" />
            </button>
          )}

          {/* Cards Container with touch events */}
          <div 
            className="overflow-hidden"
            ref={carouselRef}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{
                transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`
              }}
            >
              {focusAreas.map((area, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 px-3 md:px-4"
                  style={{ width: `${100 / cardsToShow}%` }}
                >
                  <div
                    style={{ backgroundColor: 'var(--primary-color)' }}
                    className="rounded-lg overflow-hidden shadow-lg h-full"
                  >
                    {/* Card Title */}
                    <div className="text-white text-center py-4 px-4">
                      <h3 className="font-bold">
                        {area.title}
                      </h3>
                    </div>

                    {/* Card Image */}
                    <div className="bg-white mx-4 mb-4 rounded-lg overflow-hidden">
                      <img
                        src={area.image}
                        alt={area.title}
                        className="w-full h-40 md:h-48 object-cover"
                      />
                    </div>

                    {/* Card Description */}
                    <div className="text-white text-center px-4 pb-5">
                      <p className="leading-relaxed">
                        {area.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Arrow - Hidden on mobile, visible on desktop */}
          {showRightArrow && (
            <button
              onClick={handleNext}
              className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 z-10 transition-all border-none p-0"
              aria-label="Next"
            >
              <img src='/assets/images/paltform-right-arrow.svg' alt="Next" className="w-14 h-14" />
            </button>
          )}

          {/* Dot Indicators for Mobile - Only show when there are multiple cards */}
          {focusAreas.length > 1 && (
            <div className="flex justify-center gap-2 mt-6 md:hidden">
              {Array.from({ length: focusAreas.length }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-blue-600 w-6'
                      : 'bg-gray-400'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

KeyFocusSection.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  focusAreas: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default KeyFocusSection;